var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.8166 16.4668L30.95 15.0501L31.25 11.8001L28.0833 11.0835L26.6833 10.7668L25.95 9.53346L24.3 6.73346L21.3166 8.00013L20 8.5668L18.6833 8.00013L15.7 6.7168L14.05 9.5168L13.3166 10.7501L11.9166 11.0668L8.74998 11.7835L9.04998 15.0168L9.18331 16.4335L8.24997 17.5168L6.09998 19.9835L8.24997 22.4335L9.18331 23.5168L9.04998 24.9335L8.74998 28.2001L11.9166 28.9168L13.3166 29.2335L14.05 30.4668L15.7 33.2501L18.6666 31.9668L20 31.4168L21.3166 31.9835L24.2833 33.2668L25.9333 30.4668L26.6666 29.2335L28.0666 28.9168L31.2333 28.2001L30.9333 24.9501L30.8 23.5335L31.7333 22.4501L33.8833 20.0001L31.7333 17.5501L30.8166 16.4668ZM16.8166 27.8668L10.4833 21.5168L12.95 19.0501L16.8166 22.9335L26.5666 13.1501L29.0333 15.6168L16.8166 27.8668Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3334 19.9833L34.2667 15.3333L34.8334 9.18333L28.8167 7.81667L25.6667 2.5L20 4.93333L14.3334 2.5L11.1834 7.81667L5.16669 9.16667L5.73335 15.3333L1.66669 19.9833L5.73335 24.6333L5.16669 30.8L11.1834 32.1667L14.3334 37.5L20 35.05L25.6667 37.4833L28.8167 32.1667L34.8334 30.8L34.2667 24.65L38.3334 19.9833ZM31.75 22.45L30.8167 23.5333L30.95 24.95L31.25 28.2L28.0834 28.9167L26.6834 29.2333L25.95 30.4667L24.3 33.2667L21.3334 31.9833L20 31.4167L18.6834 31.9833L15.7167 33.2667L14.0667 30.4833L13.3334 29.25L11.9334 28.9333L8.76669 28.2167L9.06669 24.95L9.20002 23.5333L8.26669 22.45L6.11669 20L8.26669 17.5333L9.20002 16.45L9.05002 15.0167L8.75002 11.7833L11.9167 11.0667L13.3167 10.75L14.05 9.51667L15.7 6.71667L18.6667 8L20 8.56667L21.3167 8L24.2834 6.71667L25.9334 9.51667L26.6667 10.75L28.0667 11.0667L31.2334 11.7833L30.9333 15.0333L30.8 16.45L31.7334 17.5333L33.8834 19.9833L31.75 22.45Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8167 22.9167L12.9501 19.0334L10.4834 21.5167L16.8167 27.8667L29.0501 15.6L26.5834 13.1167L16.8167 22.9167Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 6.09998,
    y1: 6.7168,
    x2: 36.9077,
    y2: 29.1049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE08F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEA156"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 1.66669,
    y1: 2.5,
    x2: 42.2935,
    y2: 32.0566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE08F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEA156"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 10.4834,
    y1: 13.1167,
    x2: 28.3168,
    y2: 28.7056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE08F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEA156"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.7846e2a2115bf7e31cb99f6796495a76.svg";
export { ForwardRef as ReactComponent };